import isNumber from './isNumber';
import replaceCommas from './replaceFromCommaToDot';

const numericStringToFloat = (value: string): number =>
  isNumber(value) ? replaceCommas(value) : 0;

export default numericStringToFloat;
